export const FETCH_FOOD_REQUEST = "FETCH_FOOD_REQUEST";
export const FETCH_FOOD_SUCCESS = "FETCH_FOOD_SUCCESS";
export const FETCH_FOOD_FAILURE = "FETCH_FOOD_FAILURE";

export const CREATE_FOOD_REQUEST = "CREATE_FOOD_REQUEST";
export const CREATE_FOOD_SUCCESS = "CREATE_FOOD_SUCCESS";
export const CREATE_FOOD_FAILURE = "CREATE_FOOD_FAILURE";

export const UPDATE_FOOD_REQUEST = "UPDATE_FOOD_REQUEST";
export const UPDATE_FOOD_SUCCESS = "UPDATE_FOOD_SUCCESS";
export const UPDATE_FOOD_FAILURE = "UPDATE_FOOD_FAILURE";

export const DELETE_FOOD_REQUEST = "DELETE_FOOD_REQUEST";
export const DELETE_FOOD_SUCCESS = "DELETE_FOOD_SUCCESS";
export const DELETE_FOOD_FAILURE = "DELETE_FOOD_FAILURE";

export const UPLOAD_EXCEL_FOOD_REQUEST = "UPLOAD_EXCEL_FOOD_REQUEST";
export const UPLOAD_EXCEL_FOOD_SUCCESS = "UPLOAD_EXCEL_FOOD_SUCCESS";
export const UPLOAD_EXCEL_FOOD_FAILURE = "UPLOAD_EXCEL_FOOD_FAILURE";
